/**
 * Opens the app's shared forms (the original's logModal / updateModal / projectModal / extendModal / memberModal)
 * from any page: `const act = useAppActions(); act.workLog({ projectId })`.
 */
import { useModal } from '@/app/AppContext';
import { WorkLogModal } from './worklog/WorkLogModal';
import { ProjectLogModal, ProjectPickerModal } from './projects/ProjectLogModal';
import { ProjectFormModal } from './projects/ProjectFormModal';
import { DeadlineModal } from './projects/DeadlineModal';
import { MemberFormModal } from './members/MemberFormModal';

export function useAppActions() {
  const modal = useModal();
  const actions = {
    /** Employee Log Work — add (optionally preset project / member) or edit (`id`). */
    workLog: (o: { id?: string; projectId?: string; memberId?: string } = {}) => modal.open((close) => <WorkLogModal {...o} onClose={close} />),
    /** Project Log Work — asks for the project first when neither `id` nor `projectId` is given. */
    projectLog: (o: { id?: string; projectId?: string } = {}) => {
      if (o.id || o.projectId) modal.open((close) => <ProjectLogModal id={o.id} projectId={o.projectId} onClose={close} />, { wide: true });
      else modal.open((close) => <ProjectPickerModal onClose={close} onContinue={(projectId) => actions.projectLog({ projectId })} />);
    },
    project: (id?: string) => modal.open((close) => <ProjectFormModal id={id} onClose={close} onChangeDeadline={(pid) => actions.deadline(pid)} />),
    deadline: (projectId: string) => modal.open((close) => <DeadlineModal projectId={projectId} onClose={close} />),
    member: (o: { id?: string; projectId?: string } = {}) => modal.open((close) => <MemberFormModal {...o} onClose={close} />),
  };
  return actions;
}
